var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 26.625C8.00033 28.1375 9.20033 29.375 10.667 29.375H21.3337C22.8003 29.375 24.0003 28.1375 24.0003 26.625V12.875C24.0003 11.3625 22.8003 10.125 21.3337 10.125H10.667C9.20033 10.125 8.00033 11.3625 8.00033 12.875V26.625ZM24.0003 6H20.667L19.7203 5.02375C19.4803 4.77625 19.1337 4.625 18.787 4.625H13.2137C12.867 4.625 12.5203 4.77625 12.2803 5.02375L11.3337 6H8.00033C7.26699 6 6.66699 6.61875 6.66699 7.375C6.66699 8.13125 7.26699 8.75 8.00033 8.75H24.0003C24.7337 8.75 25.3337 8.13125 25.3337 7.375C25.3337 6.61875 24.7337 6 24.0003 6Z",
    fill: "#E02B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.64c3e34f4f1b5d7137adf73164efc15f.svg";
export { ForwardRef as ReactComponent };